import Image from './style/image'
import ImageText from './style/imageText'
import RecommendImage from './recommendImage'
import SampleCard from './sampleCard'
import MultiImgCard from './inspiration/multiImgCard'
import RecoverCard from './recoverCard'
import InsColl from './inspiration/insColl'

export default { Image, InsColl, SampleCard, MultiImgCard, RecommendImage, ImageText, RecoverCard }
